export enum MessageStatus {
  NO_MESSAGES = 'no_messages',
  HAS_READ_MESSAGES = 'has_read_messages',
  HAS_UNREAD_MESSAGES = 'has_unread_messages'
}
